<template>
  <div class="section">

    <LoadingDiv v-if="!isReady" />

    <div class="card z-depth-0 grey lighten-5" v-else>
      <!-- Search -->
      <div class="card z-depth-0 grey lighten-4" :class="{ 'red lighten-5': error, 'grey lighten-4': !error }">
        <div class="card-content">
        <span v-if="enrolleeId == 0">
          <h5 class="blue-grey-text text-darken-2">{{ payer }}</h5>
          <br />
        </span>
        <nav class="white">
          <div class="nav-wrapper">
            <form @submit.prevent="handleSearch">
              <div class="input-field blue-text text-darken-2">
                <input type="search" v-model="enrolleeId" placeholder="Enrollee ID" @focus="handleClear" />
                <label class="label-icon" for="search"><i class="material-icons black-text">search</i></label>
                <i
                class="material-icons white-text orange"
                @click="handleClear"
                v-if="enrolleeGroup.length || error"
                >clear</i
              >
                <i class="material-icons" @click="handleSearch" v-else>send</i>
              </div>
            </form>
          </div>
        </nav>
       
    <div class="row card-content blue lighten-5 black-text">
     <div class="col s5">
      <label>
        <input class="with-gap" v-model="searchPeriod" :value="searchCurr" type="radio" />
        <span v-if="searchPeriod === searchCurr">Searching 
              <b>{{
                  new Date(searchCurr).toLocaleString(undefined, {
                    year: "numeric",
                    month: "long",
                  })
                }}</b> List</span>
           <span v-else>
               {{
                  new Date(searchCurr).toLocaleString(undefined, {
                    year: "numeric",
                    month: "long",
                  })
                }}
                </span>
      </label>
      </div>

      <span class="col s2"></span>

      <div class="col s5 right">
      <label>
        <input class="with-gap" v-model="searchPeriod" :value="searchPrev" type="radio" />
        <span v-if="searchPeriod === searchCurr">
               {{
                  new Date(searchPrev).toLocaleString(undefined, {
                    year: "numeric",
                    month: "long",
                  })
                }}</span>
        <span v-else>Searching 
          <b>
                {{
                  new Date(searchPrev).toLocaleString(undefined, {
                    year: "numeric",
                    month: "long",
                  })
                }}
          </b> List</span>
      </label>
      </div>
     </div>
        
     </div>
      </div>
      <div clas="row" v-if="error">
              <div class="col s12">
                <span class="left badge red white-text text-darken-2">{{ error }}</span>
              </div>
        </div>

      <div class="progress" v-if="isLoading">
        <div class="indeterminate"></div>
      </div>

      <!-- Confirmation for more than multiple enrollees -->
      <div class="card yellow lighten-5 grey-text text-darken-2" v-for="enrollee in enrolleeGroup" :key="enrollee.id">
        <div class="card-content">
          <div class="row">
            <div class="col s10">
              <span class="new badge left grey darken-2" data-badge-caption="Scheme">{{
                enrollee?.scheme.name.toUpperCase()
              }}</span>
              <br />
              <h5>{{ capWords(enrollee?.name) }} <small>({{ enrollee?.enrollee_number }})</small></h5>
            </div>
            <div class="col s2">
              <a class="btn-floating btn-large waves-effect waves-light light-blue lighten-2 pulse right"><i
                  class="material-icons" @click.prevent="handleStart(enrollee)" title="details">chevron_right</i></a>
            </div>
          </div>
        </div>
      </div>

      <br />
    </div>

  </div>
</template>

<script>
import { ref, onMounted, watch, watchEffect } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { capWordsFx } from "@/composables/fxLibrary/coreFx";
import { HMO } from '@/laravel/config';
import LoadingDiv from "@/components/LoadingDiv.vue";
import getItemsOfItems from "@/composables/getItemsOfItems";
import { getCurr, getPrev } from "@/composables/encounter/eligible";
import { getFullMonthName } from "@/composables/fxLibrary/months";

export default {
  name: "StartAuthComponent",
  props: ["serverTime"],
  components: { LoadingDiv },
  emits: ["next"],
  setup(props, context) {
    const isReady = ref(false);
    const response = ref(null);
    const enrolleeGroup = ref([]);
    const enrolleeId = ref(null);
    const serverDate = ref(null);
    const searchPeriod = ref(null);
    const searchCurr = ref(null);
    const searchPrev = ref(null);
    const error = ref(false);
    const isLoading = ref(false);
    const endPoint = ref(null);
    const callFunction = ref(null);

    // vue router
    const router = useRouter();

    // store
    const store = useStore();

    // config
    const providerId = store.state?.user?.account?.id;

    // watch 
    watch(() => searchPeriod.value, () => {
    handleClear();
    }
    );

    // load endpoint
    onMounted(() => {
      // check and set
      if (props.serverTime?.current_date_full) {

      // get month periods
      searchPeriod.value = getCurr(props.serverTime?.current_date_full);
      searchCurr.value = getCurr(props.serverTime?.current_date_full);
      searchPrev.value = getPrev(props.serverTime?.current_date_full);

      // now ready
      isReady.value = true;
      isLoading.value = false;

      } else {
        // encounter didnt load properly
        router.push({ name: "home" });
      }

    })

    // load endpoint
    onMounted(() => {
       // default endpoint
        endPoint.value = "operator/enrollee/encounter/checker";
        // default call function
        callFunction.value = getItemsOfItems;
    })

    //from functions
    const capWords = (val) => {
      return capWordsFx(val);
    };

    // get function
    const getSearchItemsFromApi = (table, match) => {
      // loading starts
      isLoading.value = true;
      // clear error
      error.value = null;

      (async () => {
        const { res } = await callFunction.value(table, match);

        if (res.value && res.value.status) {
          // set server date
          serverDate.value = res.value.server;
          // display options
          if (res.value.data.length === 1) {
            response.value = res.value.data[0];
          } else {
            enrolleeGroup.value = res.value.data;
          }
        } else {
          let date = searchPeriod.value.split("-");
          error.value = `Sorry, Enrollee not on ${HMO} ${getFullMonthName(date[1] - 1)} List`;
          response.value = null; // clear standing response
        }

        // page is ready, loading is complete
        isLoading.value = false;
      })();
    };

    // search
    const handleSearch = () => {
      // loading starts
      if (enrolleeId.value) {
      // start loading
      isLoading.value = true;
      // val
      let date = searchPeriod.value.split("-");
      // val
      let val = `?y=${date[0]}&m=${date[1]}&q=${enrolleeId.value.trim()}`;
      // search: 0 = provider_id // serach all providers
      getSearchItemsFromApi(endPoint.value, `${providerId}${val}`);
      }
    };

    // start
    const handleStart = (val) => {
      // set
      response.value = val;
    }

    // clear
    const handleClear = () => {
      enrolleeGroup.value = [];
      enrolleeId.value = null;
      response.value = null;
      error.value = false;
    };

    // next
    watchEffect(() => {
      if (response.value) {
        context.emit("next", {
          value: response.value,
          serverDate: serverDate.value,
          searchPeriod: searchPeriod.value
        });
      }
    });

    return {
      capWords,
      handleStart,
      handleSearch,
      handleClear,
      error,
      isLoading,
      isReady,
      searchPeriod,
      searchCurr,
      searchPrev,
      enrolleeGroup,
      enrolleeId,
      payer: HMO,
    };
  },
};
</script>

<style scoped>
.progress {
  margin-top: -15px;
}
</style>